import * as React from 'react';
import styled from 'styled-components';

import IViewProps from '../../IViewProps';
import Colors from '../../lib/Colors';
import ButtonFooter from '../ButtonFooter';
import CardWithHeader from '../CardWithHeader';
import EmailAndProfile from './EmailAndProfile';
import { Spinner } from 'react-activity';

function UnstyledConfirmPurchase(props: IViewProps) {
  const rewardCategory = props.rewardCategories.find(
    r => r.id === props.rewardCategoryId,
  );
  if (!rewardCategory) {
    return null;
  }

  const reward = props.rewards.find(r => r.id === props.rewardId);
  if (!reward) {
    return null;
  }

  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isConfirmed, setIsConfirmed] = React.useState(false);

  const editAddressButton = <button
    disabled={!isLoaded || isConfirmed}
    onClick={props.onShowAddressEditor}
    className="secondary"
  >
    Adresse korrigieren
  </button>;

  const confirmButton = <button
    disabled={!isLoaded || isConfirmed}
    onClick={() => {
      setIsConfirmed(true);
      if (props.onConfirmPurchase) {
        props.onConfirmPurchase();
      }
    }}
  >
    Bestätigen und bestellen
  </button>;

  const activityIndicator = <>
    <span>Bestellung wird gesendet…</span>
    <Spinner size={10} />
  </>;

  const smilesText = reward.vipAmount > 0 ?
      <section className="description">Du hast aktuell {props.credits} Prämien Smiles und&nbsp;
        {props.vipCredits} Treue Status Smiles auf Deinem Nutzerkonto. Für diese Prämie löst
       Du jetzt {reward.amount} Prämien Smiles und {reward.vipAmount} Treue Status Smiles ein.
      </section>
      : <section className="description">Du hast aktuell {props.credits} Smiles auf Deinem
        Nutzerkonto. Für diese Prämie löst Du jetzt {reward.amount} Smiles ein.</section>;

  const footer = <ButtonFooter>{isConfirmed ? activityIndicator : confirmButton}</ButtonFooter>;

  return (
    <CardWithHeader
      footer={footer}
      title="Punkteeinlösung bestätigen"
      className={props.className}
      onGoBack={props.onGoBack}
    >
      <section className="reward">
        <section className="reward-name">
          <img src={rewardCategory.imageUrl} className="reward-icon" />
          <span>
            {rewardCategory.name} / {reward.name}
          </span>
        </section>
      </section>
      <section>
        <span>
          {smilesText}
        </span>
      </section>
      <section className="address">
        <header>Versand an:</header>
        <EmailAndProfile onLoad={() => setIsLoaded(true)} />
        {editAddressButton}
      </section>
    </CardWithHeader>
  );
}

const ConfirmPurchase = styled(UnstyledConfirmPurchase)`
  section.reward {
    padding: 1rem;
  }

  section.address {
    padding: 0 1rem 1rem 1rem;
    line-height: 1.5;
    header {
      color: ${Colors.mutedText};
    }
    button {
      padding: 0.5rem 1rem;
      font-size: 1rem;
      color: white;
      background-color: ${Colors.secondary};

      &:disabled {
        opacity: 0.3;
      }
    }
  }

  section.reward-name,
  section.email-address,
  section.profile {
    word-break: break-word;
    font-size: 1.2rem;
  }

  section.email-address,
  section.profile {
    margin-top: 1rem;
    font-weight: 500;
  }

  section.email-address {
    footer {
      color: ${Colors.mutedText};
      font-size: 1rem;
    }
  }

  section.reward-name {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      margin: 0.5rem 0;
    }
  }

  img.reward-icon {
    width: 5rem;
    height: 5rem;
    margin-right: 1rem;
    object-fit: contain;
  }

  address {
    font-style: normal;
  }

  > footer {
    flex-direction: row;
    justify-content: space-between;
    span, .rai-activity-indicator {
      align-self: center;
    }
  }

  section.description {
    padding: 0.5rem 1.2rem;
    font-size: 0.9rem;
    line-height: 1.333;
    color: ${Colors.mutedText};
  }
`;

export default ConfirmPurchase;



// WEBPACK FOOTER //
// ./src/components/ConfirmPurchase/ConfirmPurchase.tsx